import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import './App.css';

// Secure password - no hint on screen
const CORRECT_PASSWORD = import.meta.env.VITE_MC_PASSWORD || 'kss30kmrr';

function App() {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const auth = localStorage.getItem('mission-control-auth');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
    setTimeout(() => setLoading(false), 800);
  }, []);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      localStorage.setItem('mission-control-auth', 'true');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Access denied. Seek wisdom.');
      setPassword('');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('mission-control-auth');
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="login-page">
        <div className="login-content">
          <div className="login-brand">
            <div className="login-crest">👑</div>
            <h1>Mission Control</h1>
            <p className="subtitle">Establishing Connection...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="login-page">
        <div className="login-content">
          <div className="login-brand">
            <div className="login-crest">👑</div>
            <h1>Mission Control</h1>
            <p className="subtitle">Authorized Personnel Only</p>
          </div>
          <div className="login-form-container">
            <h2>Enter Access Code</h2>
            <p className="hint">The wise know the value of protection.</p>
            <form onSubmit={handleLogin}>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter access code..."
                className="login-input"
                autoFocus
              />
              {error && <p className="login-error">{error}</p>}
              <button type="submit" className="login-button">
                Access Mission Control
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="dashboard">
        <Dashboard onLogout={handleLogout} />
      </div>
    </Router>
  );
}

export default App;
// Force rebuild Fri Feb 27 08:13:27 MST 2026
// Cache bust 1772208110
